import { combineReducers } from "redux";
import NotificationReducer from "./NotificationReducer";
import NavigationReducer from "./NavigationReducer";
import AlertReducer from "./AlertReducer";
import SearchReducer from "./SearchReducer";
import adminReducer from "./AdminReducer";
import AuthReducer from "./auth-reducer";
import ThemeReducer from "./theme-reducer";
import ToastReducer from "./toast-reducer";
import LedgerEnvReducer from "./ledger-env-reducer";

const RootReducer = combineReducers({
  notifications: NotificationReducer,
  navigations: NavigationReducer,
  alerts: AlertReducer,
  search: SearchReducer,
  admin: adminReducer,
  auth: AuthReducer,
  theme: ThemeReducer,
  toast: ToastReducer,
  ledgerEnv: LedgerEnvReducer,
});

export default RootReducer;
